import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, Field, reduxForm } from 'redux-form';
import {renderFieldNumeros, renderFieldSelect, requiredSelect} from '../../util/inputs';
import cadastrarMapaVeiculo from '../../actions/mapa-veiculo/cadastrarMapaVeiculo';
import $ from 'jquery';
import {campoTipoVeiculo} from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (values.quantidadeAssentos > 300) {
    errors.quantidadeAssentos = 'Quantidade máxima permitida: 300'
  }
  if (values.quantidadeCorredores > 2) {
    errors.quantidadeCorredores = 'Quantidade máxima permitida: 2'
  }
  if (values.quantidadeFileiras > 4) {
    errors.quantidadeFileiras = 'Quantidade máxima permitida: 4'
  }

  return errors
};

const REMOVIDO = 'REMOVIDO';
const BANHEIRO = 'BANHEIRO';
const PORTA = 'PORTA';
const TROCAR_NUMERO = 'TROCAR_NUMERO'


export const mapaTiposAssentos = new Map([
  [REMOVIDO, {
    cor: '#b6b6b6',
    textColor: '#b6b6b6'
  }],
  [PORTA, {
    cor: '#fee23f',
    textColor: '#757575'
  }],
  [BANHEIRO, {
    cor: '#fe5d7d',
    textColor: '#fe5d7d'
  }],
  [TROCAR_NUMERO, {
    cor: 'green',
    textColor: '#ffffff'
  }]
]);


function tratarMarcarPorta (fileira, assento) {
  const novaFileira = {
    ...fileira,
    assentos: []
  };
  fileira.assentos.forEach((it) => {
    if (it.ordem === assento.ordem) {
      if (it.tipoAssento && it.tipoAssento === PORTA) {
        return
      }
      novaFileira.assentos.push({
        numero: '',
        ordem: novaFileira.assentos.length,
        tipoAssento: PORTA
      })
    }
    novaFileira.assentos.push({
      numero: it.numero,
      ordem: novaFileira.assentos.length,
      tipoAssento: it.tipoAssento
    })
  });
  return novaFileira
}

function tratarRemoverAssento (fileira, assento) {
  const novaFileira = {
    ...fileira,
    assentos: []
  };
  fileira.assentos.forEach((it) => {
    if (it.ordem === assento.ordem) {
      if (it.tipoAssento && it.tipoAssento === PORTA) {
        return
      }
      if (it.tipoAssento && it.tipoAssento === this.id) {
        novaFileira.assentos.push({
          numero: it.numero,
          ordem: novaFileira.assentos.length,
          tipoAssento: ''
        })
      } else {
        novaFileira.assentos.push({
          numero: it.numero,
          ordem: novaFileira.assentos.length,
          tipoAssento: this.id
        })
      }
    } else {
      novaFileira.assentos.push({
        numero: it.numero,
        ordem: novaFileira.assentos.length,
        tipoAssento: it.tipoAssento
      })
    }
  });
  return novaFileira
}

const listaAcoes = [{
  id: REMOVIDO,
  descricao: 'Remover assento',
  tratarMarcacao: tratarRemoverAssento
},
  {
    id: BANHEIRO,
    descricao: 'Marcar banheiro',
    tratarMarcacao: tratarRemoverAssento
  },
  {
    id: PORTA,
    descricao: 'Marcar porta',
    tratarMarcacao: tratarMarcarPorta
  },
  {
    id: TROCAR_NUMERO,
    descricao: 'Alterar número'
  }];

export const ModalTrocarNumeroAssento = ({ alterarNumeroAssento, handleNumeroAssentoSelecionado, andar }) => (
  <div className="modal fade" id={`modalTrocarNumeroAssento${andar}`} tabIndex="-1" role="dialog"
       aria-labelledby={`modalTrocarNumeroAssento${andar}`} aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div className="modal-content">
        <div className="modal-body">
          <div>
            <label>Informe um novo número</label>
            <Field name="assento" type="text" component={renderFieldNumeros}
                   formatacao='##'
                   css="form-control col-3" readOnly={false}
                   onChange={(event) => handleNumeroAssentoSelecionado(event.target.value)}
            />
          </div>
        </div>
        <div className="modal-footer ">
          <button id='cancelar' type="button" className="btn btn-outline-secondary"
                  data-dismiss="modal">Cancelar
          </button>
          <button type="button" className="btn btn-azul float-left"
                  data-dismiss="modal"
                  onClick={() => alterarNumeroAssento()}>Salvar
          </button>
        </div>
      </div>
    </div>
  </div>);

export class PainelCadastroMapaVeiculo extends React.Component {
  constructor (props) {
    super(props);
    this.handleSelecionarTipoVeiculo = this.handleSelecionarTipoVeiculo.bind(this);
    this.state = {
      fileiraUm: {
        numero: 1,
        assentos: [],
        exibeCorredor: false
      },
      fileiraDois: {
        numero: 2,
        assentos: [],
        exibeCorredor: false
      },
      fileiraTres: {
        numero: 3,
        assentos: [],
        exibeCorredor: true
      },
      fileiraQuatro: {
        numero: 4,
        assentos: [],
        exibeCorredor: false
      },
      quantidadeCorredores: 1,
      tipoAcaoSelecionada: '',
      quantidadeFileiras: 4,
      quantidadeAssentos: 44,
      fileiraSelecionda: null,
      assentoSelecionado: null,
      numeroAssentoInformado: null,
      tipoVeiculo: null
    };
  }

  componentDidMount () {
    this.gerarMapa(this.state.quantidadeAssentos, this.state.quantidadeFileiras, this.state.quantidadeCorredores)
  }


  gerarMapa (qtdAssentos, qtddeFileiras, qtdCorredores) {
    // eslint-disable-next-line radix
    const quantidadeAssentos = parseInt(qtdAssentos);
    // eslint-disable-next-line radix
    const quantidadeFileiras = parseInt(qtddeFileiras);
    // eslint-disable-next-line radix
    const quantidadeCorredores = parseInt(qtdCorredores);
    this.setState({
      quantidadeAssentos,
      quantidadeFileiras,
      quantidadeCorredores
    });
    if (quantidadeAssentos > 300) {
      return
    }
    let contador = 1;
    const fileiraUm = {
      numero: 1,
      assentos: [],
      exibeCorredor: false
    };
    const fileiraDois = {
      numero: 2,
      assentos: [],
      exibeCorredor: this.definirFileira(2, quantidadeFileiras, quantidadeCorredores)
    };
    const fileiraTres = {
      numero: 3,
      assentos: [],
      exibeCorredor: true
    };
    const fileiraQuatro = {
      numero: 4,
      assentos: [],
      exibeCorredor: this.definirFileira(4, quantidadeFileiras, quantidadeCorredores)
    };
    for (let i = 1; i <= quantidadeAssentos; i += 1) {
      switch (contador) {
        case 1: {
          fileiraUm.assentos.push({
            numero: i,
            ordem: fileiraUm.assentos.length
          });
          if (quantidadeFileiras === 1) {
            contador = 0;
          }
          break
        }
        case 2: {
          fileiraDois.assentos.push({
            numero: i,
            ordem: fileiraDois.assentos.length
          });
          if (quantidadeFileiras === 2) {
            contador = 0;
          }
          break
        }
        case 3: {
          fileiraQuatro.assentos.push({
            numero: i,
            ordem: fileiraQuatro.assentos.length
          });
          if (quantidadeFileiras === 3) {
            contador = 0;
          }
          break
        }
        case 4: {
          contador = 0;
          fileiraTres.assentos.push({
            numero: i,
            ordem: fileiraTres.assentos.length
          });
          break
        }
        default: {
          break
        }
      }
      contador += 1;
    }
    this.setState({
      fileiraUm,
      fileiraDois,
      fileiraTres,
      fileiraQuatro
    })
  }

  redistribuirNumeracao (numeroInicial) {
    // eslint-disable-next-line radix,no-restricted-globals
    if (isNaN(parseInt(numeroInicial))) {
      return
    }
    // eslint-disable-next-line radix
    let contadorNumero = parseInt(numeroInicial) - 1;
    const todosAssentos = [...this.state.fileiraUm.assentos, ...this.state.fileiraDois.assentos, ...this.state.fileiraTres.assentos, ...this.state.fileiraQuatro.assentos].sort((n1, n2) => {
      if (n1.ordem > n2.ordem) {
        return 1;
      }

      if (n1.ordem < n2.ordem) {
        return -1;
      }

      return 0;
    });
    let contador = 1;
    const fileiraUm = [];
    const fileiraDois = [];
    const fileiraTres = [];
    const fileiraQuatro = [];
    for (let i = 0; i < todosAssentos.length; i += 1) {
      let numero = '';
      if (todosAssentos[i].tipoAssento !== PORTA
        && todosAssentos[i].tipoAssento !== BANHEIRO
        && todosAssentos[i].tipoAssento !== REMOVIDO) {
        contadorNumero += 1;
        numero = contadorNumero;
      }
      switch (contador) {
        case 1: {
          fileiraUm.push({
            ...todosAssentos[i],
            numero,
            ordem: fileiraUm.length
          });
          if (this.state.quantidadeFileiras === 1) {
            contador = 0;
          }
          break
        }
        case 2: {
          fileiraDois.push({
            ...todosAssentos[i],
            numero,
            ordem: fileiraDois.length
          });
          if (this.state.quantidadeFileiras === 2) {
            contador = 0;
          }
          break
        }
        case 3: {
          fileiraQuatro.push({
            ...todosAssentos[i],
            numero,
            ordem: fileiraQuatro.length
          });
          if (this.state.quantidadeFileiras === 3) {
            contador = 0;
          }
          break
        }
        case 4: {
          fileiraTres.push({
            ...todosAssentos[i],
            numero,
            ordem: fileiraTres.length
          });
          contador = 0;
          break
        }
        default: {
          break
        }
      }
      contador += 1;
    }

    this.setState({
      fileiraUm: {
        ...this.state.fileiraUm,
        assentos: fileiraUm
      },
      fileiraDois: {
        ...this.state.fileiraDois,
        assentos: fileiraDois
      },
      fileiraTres: {
        ...this.state.fileiraTres,
        assentos: fileiraTres
      },
      fileiraQuatro: {
        ...this.state.fileiraQuatro,
        assentos: fileiraQuatro
      },
    })
  }

  // eslint-disable-next-line class-methods-use-this
  definirFileira (numeroFila, quantidadeFileiras, quantidadeCorredores) {
    if (numeroFila === 2) {
      if (quantidadeFileiras === 2 && quantidadeCorredores === 1) {
        return true;
      }
      if (quantidadeFileiras === 3 && quantidadeCorredores === 2) {
        return true;
      }
    }
    return false
  }

  marcarPoltrona (fileira, assento, numeroFileira) {
    if (this.state.tipoAcaoSelecionada && this.state.tipoAcaoSelecionada.id === TROCAR_NUMERO) {
      this.setState({
        fileiraSelecionada: fileira,
        assentoSelecionado: assento
      })
      $(`#modalTrocarNumeroAssento${this.props.andar}`)
        .modal('show');
      return
    }

    if (this.state.tipoAcaoSelecionada) {
      switch (numeroFileira) {
        case 1:
          this.setState({ fileiraUm: this.state.tipoAcaoSelecionada.tratarMarcacao(fileira, assento) });
          break;
        case 2:
          this.setState({ fileiraDois: this.state.tipoAcaoSelecionada.tratarMarcacao(fileira, assento) });
          break;
        case 3:
          this.setState({ fileiraTres: this.state.tipoAcaoSelecionada.tratarMarcacao(fileira, assento) });
          break;
        case 4:
          this.setState({ fileiraQuatro: this.state.tipoAcaoSelecionada.tratarMarcacao(fileira, assento) });
          break;
        default:
          break;
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  exibirFileira (fileira, numeroFileira) {
    if (fileira.assentos.length > 0) {
      return (
        <div className="transport-meio-fileira" key={`fileira-${numeroFileira}-${this.props.andar}`}>
          {this.exibirAssentos(fileira, numeroFileira)}
          <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
        </div>
      )
    }
  }

  // eslint-disable-next-line class-methods-use-this
  exibirCorredor (fileira, numeroFileira) {
    return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor${numeroFileira}`}/> : '')
  }

  exibirAssentos (fileira, numeroFileira) {
    return fileira.assentos.map(assento => <div key={`assento-${this.props.andar}-${numeroFileira}-${assento.ordem}`}
                                                onClick={() => this.marcarPoltrona(fileira, assento, numeroFileira)}>
      <label className={'assento assento-disponivel  js-seat-selected-amplitude'} style={{
        backgroundColor: assento.tipoAssento ? mapaTiposAssentos.get(assento.tipoAssento).cor : '',
        color: assento.tipoAssento ? mapaTiposAssentos.get(assento.tipoAssento).textColor : ''
      }}>
        {assento.numero}
      </label>
    </div>)
  }

  renderAcao (acao, indice) {
    return <li key={`acao${indice}`} className="list-group-item" style={{
      cursor: 'pointer',
      backgroundColor: this.state.tipoAcaoSelecionada.id === acao.id ? mapaTiposAssentos.get(acao.id).cor : ''
    }}
               onClick={() => this.setState({ tipoAcaoSelecionada: acao })}>
      <i className="material-icons nav-icon" style={{
        position: 'absolute',
        marginLeft: '-20px',
        color: mapaTiposAssentos.get(acao.id).cor
      }}>&#xe866;</i><span className='ml-2'>{acao.descricao}</span></li>
  }

  exibirAcoes () {
    if (this.state.fileiraUm.assentos.length && !this.props.edicaoBloqueada) {
      return <div id='exibir-menu-acoes' className='d-flex justify-content-center'>
          <div className="card mt-2">
            <div className="card-header text-center">
              Ações
            </div>
            <ul className="list-group list-group-horizontal">
              {listaAcoes.map((acao, index) => this.renderAcao(acao, index))}
            </ul>
          </div>
      </div>
    }
  }

  handleSelecionarTipoVeiculo(evento) {
    this.props.selecionarTipoVeiculo(evento);
  }

  submit () {
    this.props.adicionarFileiras([this.state.fileiraUm, this.state.fileiraDois, this.state.fileiraTres, this.state.fileiraQuatro])
    this.setState({ tipoAcaoSelecionada: '' });
  }

  exibirBotoes () {
    return (
      <div id='botao-concluir-mapa' className="d-flex flex-row-reverse mb-4 mr-4">
        <button className="btn btn-laranja pull-right">
          {this.props.edicaoBloqueada ? 'Editar' : 'Concluir'}
        </button>
      </div>
    )
  }

  exibirCampos () {
    if (!this.props.edicaoBloqueada) {
      return (<div id='menu-opcoes-form' className='d-flex justify-content-center mt-4'>
        <Field name="quantidadeAssentos" type="text" component={renderFieldNumeros} formatacao='###'
               label="Assentos:"
               valor={this.state.quantidadeAssentos}
               css="form-control col-md-8" readOnly={false}
               onChange={e => this.gerarMapa(e.target.value, this.state.quantidadeFileiras, this.state.quantidadeCorredores)}/>
        <Field name="quantidadeFileiras" type="text" component={renderFieldNumeros} formatacao='#'
               label="Fileiras:"
               valor={this.state.quantidadeFileiras}
               css="form-control col-md-8" readOnly={false}
               onChange={e => this.gerarMapa(this.state.quantidadeAssentos, e.target.value, this.state.quantidadeCorredores)}/>
        <Field name="quantidadeCorredores" type="text" component={renderFieldNumeros} formatacao='#'
               label="Corredores:"
               valor={this.state.quantidadeCorredores}
               onChange={e => this.gerarMapa(this.state.quantidadeAssentos, this.state.quantidadeFileiras, e.target.value)}
               css="form-control col-md-8" readOnly={false}/>
        <Field name="numeroInicial" type="text" component={renderFieldNumeros} formatacao='##'
               label="Redistribuir:"
               css="form-control col-md-8" readOnly={false} onChange={e => this.redistribuirNumeracao(e.target.value)}/>
        <div className='col-4'>
          <Field name='tipoVeiculo'
                 options={campoTipoVeiculo.map(elemento => ({
                   descricao: elemento.valor,
                   nome: elemento.chave
                 }))}
                 placeholder='Selecione...'
                 onChange={(e) => this.handleSelecionarTipoVeiculo(e)}
                 component={renderFieldSelect}
                 label='Tipo Veículo:' validate={requiredSelect}
          />
        </div>
      </div>)
    }
    return '';
  }

  handleNumeroAssentoSelecionado (numero) {
    this.setState({ numeroAssentoInformado: numero })
  }

  alterarNumeroAssento () {
    const { fileiraSelecionada, assentoSelecionado, numeroAssentoInformado } = this.state;
    const novaFileira = fileiraSelecionada
    const indiceAssento = fileiraSelecionada.assentos.indexOf(assentoSelecionado)
    fileiraSelecionada.assentos[indiceAssento] = {
      ...assentoSelecionado,
      numero: numeroAssentoInformado
    }
    switch (fileiraSelecionada.numero) {
      case 1:
        this.setState({ fileiraUm: fileiraSelecionada });
        break;
      case 2:
        this.setState({ fileiraDois: fileiraSelecionada });
        break;
      case 3:
        this.setState({ fileiraTres: fileiraSelecionada });
        break;
      case 4:
        this.setState({ fileiraQuatro: fileiraSelecionada });
        break;
      default:
        break;
    }
    this.props.changeFieldValue('formCadastroVeiculo',
      'assento', '');
    return novaFileira
  }

  render () {
    const {
      handleSubmit
    } = this.props;
    return (
      <form id='form-cardInicial' className='card card-inicial' onSubmit={handleSubmit(this.submit.bind(this))}>
        <h3 className='text-center mt-2'>{this.props.andar === 1 ? '1º andar' : '2º andar'}</h3>
        {this.exibirCampos()}
        {this.exibirAcoes()}
        <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
          <div className="js-count-transport">
            <div className="transport bus-design bus-design-side ">
              <div className="transport-frente"/>
              <div className="transport-meio transport-meio-thin">
                {this.exibirFileira(this.state.fileiraQuatro, 4)}
                {this.exibirCorredor(this.state.fileiraQuatro, 4)}
                {this.exibirFileira(this.state.fileiraTres, 3)}
                {this.exibirCorredor(this.state.fileiraTres, 3)}
                {this.exibirFileira(this.state.fileiraDois, 2)}
                {this.exibirCorredor(this.state.fileiraDois, 2)}
                {this.exibirFileira(this.state.fileiraUm, 1)}
              </div>
              <div className="transport-traseira"/>
            </div>
          </div>
        </div>
        <ModalTrocarNumeroAssento
          andar={this.props.andar}
          alterarNumeroAssento={this.alterarNumeroAssento.bind(this)}
          handleNumeroAssentoSelecionado={this.handleNumeroAssentoSelecionado.bind(this)}/>
        {this.exibirBotoes()}
      </form>
    )
  }
}


export default connect(null,
  { cadastrarMapaVeiculo,  changeFieldValue })(reduxForm({
  form: 'formCadastroVeiculo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(PainelCadastroMapaVeiculo))
